import { useState, lazy, Suspense } from "react";
import { Camera } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BottomDrawer } from "@/components/ui/bottom-sheet";
import { cn } from "@/lib/utils";

// Lazy load the heavy scanner component
const QRScanner = lazy(() => import("./QRScanner").then(m => ({ default: m.QRScanner })));

interface QRScannerButtonProps {
  className?: string;
}

export function QRScannerButton({ className }: QRScannerButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        aria-label="Open QR scanner"
        onClick={() => setOpen(true)}
        className={cn("min-w-[44px] min-h-[44px]", className)}
      >
        <Camera className="h-5 w-5" />
      </Button>

      <BottomDrawer
        open={open}
        onOpenChange={setOpen}
        title=""
        className="h-screen"
      >
        <div className="absolute inset-0 pt-0">
          <Suspense fallback={
            <div className="flex items-center justify-center h-full">
              <div className="flex flex-col items-center gap-4">
                <div className="relative w-16 h-16">
                  <div className="absolute inset-0 border-4 border-primary/20 rounded-xl animate-spin" style={{ animationDuration: '3s' }} />
                  <div className="absolute inset-2 border-4 border-primary/40 rounded-lg animate-spin" style={{ animationDuration: '2s', animationDirection: 'reverse' }} />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <Camera className="h-8 w-8 text-primary" />
                  </div>
                </div>
                <p className="text-sm text-muted-foreground">Loading scanner...</p>
              </div>
            </div>
          }>
            {open && (
              <QRScanner
                onScan={(result) => {
                  console.log("Scanned:", result);
                }}
                onClose={() => setOpen(false)}
              />
            )}
          </Suspense>
        </div>
      </BottomDrawer>
    </>
  );
}
